/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FunctionComponent, useCallback } from 'react';
import { Skeleton } from '@doveit/lego';
import Link from 'next/link';
import Image from 'next/image';
import * as styles from './ArticleSmallCard.style';
import { goToPage, URLObject } from '../../utils/links';

export interface ArticleSmallCardProps {
  title: string,
  dataRef?: string,
  date?: string,
  urlObject: URLObject,
  onClick?: (path: string) => void,
  thumbnail?: {
    alt: string,
    url: string,
  },
}

export const ArticleSmallCardSkeleton = () => (
  <div css={styles.base}>
    <div css={styles.thumbnail}>
      <Skeleton
        width={styles.THUMBNAIL_WIDTH}
        height={styles.THUMBNAIL_HEIGHT}
      />
    </div>
    <div css={styles.info}>
      <Skeleton count={2} />
    </div>
  </div>
);

const ArticleSmallCard: FunctionComponent<ArticleSmallCardProps> = ({
  title,
  dataRef = 'article-small-card',
  urlObject,
  onClick,
  date,
  thumbnail,
}) => {
  const internalOnClick = useCallback((path: string) => () => {
    if (onClick) {
      onClick(path);
    } else {
      goToPage(urlObject);
    }
  }, [onClick, urlObject]);

  return (
    <article
      css={styles.base}
      dataRef={dataRef}
      onClick={internalOnClick(urlObject.as)}
    >
      <div css={styles.thumbnail}>
        {thumbnail && (
          <Image
            src={thumbnail.url}
            width={90}
            height={60}
            alt={thumbnail.alt}
          />
        )}
      </div>
      <div css={styles.info}>
        <div>
          <Link
            href={urlObject.url}
            as={urlObject.as}
          >
            {title}
          </Link>
        </div>
        {date && (
          <time css={styles.details}>
            {date}
          </time>
        )}
      </div>
    </article>
  );
};

export default ArticleSmallCard;
